import type { AccessConstraint } from '@sb/shared/access';
import { featureFlag } from '@sb/shared/feature';

/** Access constraints for the hiring routes. */
export const hiringAccess = {
  templates: { permission: 'Manage contract templates', featureFlag: featureFlag.TMP_CONTRACT_TEMPLATE },
  'new-hires': { permission: 'Manage new hires', featureFlag: featureFlag.TMP_CONTRACT_TEMPLATE },
} satisfies Record<string, AccessConstraint>;
